import styled from '@emotion/styled';

import { font } from '../../../Font/Font.styles';

export const StyledLabel = styled.label`
  ${font('body-md')};
  color: var(--color-black);
`;
